
import dayjs from "dayjs";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import vuexStore from "@/store/vuex-store";
import {
  EnumProcessStatus,
  EnumSubmitStatus,
  CandidateItem,
  EnumAutoSubmitType
} from "@/lib/model/exambuilder/exam-component/candidate";
import EllipShow from "@/components/ellipShow.vue";

@Component({
  components: {
    EllipShow
  }
})
export default class CandidateItemCom extends Vue {
  @Prop() item!: CandidateItem;
  @Prop() versionList!: { label: string; value: number }[];
  @Prop({ type: String, default: "all" })
  scene!: "exam" | "all";

  isHover = false;
  V = vuexStore;

  aiRecommendStatus = {
    0: "-",
    10: "不推荐",
    20: "一般",
    30: "推荐",
    40: "非常推荐"
  };

  auditStatus = {
    0: "-",
    1: "通过",
    2: "待定",
    3: "拒绝"
  };

  submitStatus = {
    0: "未登记",
    1: "面试中",
    2: "已交卷",
    3: "已登记",
    4: "已交卷"
  };

  isBottom = false;

  get EnumProcessStatus() {
    return EnumProcessStatus;
  }

  get findVersion() {
    const el = this.versionList.find(
      version => version.value === this.item.examVersionId
    );
    console.log(el);
    return el ? el.label : "";
  }

  // 交卷类型
  get submitType() {
    return {
      [EnumAutoSubmitType.Timeout]: "系统自动结束",
      [EnumAutoSubmitType.Screenshot]: "截屏触发强制交卷",
      [EnumAutoSubmitType.MobileJoinCount]: "切屏触发强制交卷",
      [EnumAutoSubmitType.Lr1]: "人脸核验匹配失败强制交卷",
      [EnumAutoSubmitType.Lr2]: "人脸核验超过最大次数强制交卷",
      [EnumAutoSubmitType.Expire]: "面试过期自动结束",
      [EnumAutoSubmitType.Repeat]: "系统新增邀请记录触发强制交卷",
      [EnumAutoSubmitType.NameIdCheck]: "姓名或证件号与实际证件不匹配强制交卷"
    };
  }

  formatAtMin(timeStr: string) {
    return dayjs(timeStr).format("YYYY-MM-DD HH:mm");
  }

  scoreAiConvert(
    submitStatus: EnumSubmitStatus,
    scoreAi: number,
    aiProcessStatus: EnumProcessStatus
  ) {
    if (
      [
        EnumSubmitStatus.EnumSubmitStatusNotSignIn,
        EnumSubmitStatus.EnumSubmitStatusSignIn,
        EnumSubmitStatus.EnumSubmitStatusAnswering
      ].includes(submitStatus)
    ) {
      return "-";
    }

    if (
      [
        EnumSubmitStatus.EnumSubmitStatusFinish,
        EnumSubmitStatus.EnumSubmitStatusNoScore
      ].includes(submitStatus)
    ) {
      return aiProcessStatus === EnumProcessStatus.EnumProcessStatusFinish
        ? scoreAi + "分"
        : "正在打分";
    }
  }

  aiCommentConvert(aiComment: string, aiProcessStatus: EnumProcessStatus) {
    if (
      !aiComment ||
      aiProcessStatus !== EnumProcessStatus.EnumProcessStatusFinish
    ) {
      return "-";
    }

    return aiComment;
  }

  getPosition(e: any) {
    const rect = (e.target as HTMLElement).getBoundingClientRect();
    this.isBottom = rect.top <= 258;
  }

  get canToReport() {
    if ([0, 1, 3].includes(this.item.submitStatus)) {
      return false;
    }

    return true;
  }

  toReport() {
    if (this.canToReport) {
      this.operate("watchReport");
    }
  }

  @Emit()
  operate(flag: string, e?: any) {
    if (e?.disabled) return;

    return {
      flag,
      row: this.item
    };
  }

  @Emit()
  quickSearch(type: string) {
    return type;
  }

  @Emit()
  showError() {
    return this.item;
  }
}
